export default __webpack_public_path__ + "static/media/tomato.b8c0e59a.png";